import React, { useState, useEffect } from "react";
import LeadsOverviewChart from "../widgetsCharts/LeadsOverviewChart";
import LatestLeads from "../widgetsTables/LatestLeads";
import Schedule from "../widgetsList/Schedule";

import { useNavigate, useLocation } from "react-router-dom";


import SiteOverviewStatistics from "../widgetsStatistics/SiteOverviewStatistics";
import TasksOverviewChart from "../widgetsCharts/TasksOverviewChart";
import SalesMiscellaneous from "../widgetsMiscellaneous/SalesMiscellaneous";
import PageHeaderDate from "../shared/pageHeader/PageHeaderDate";
import PageHeader from "../shared/pageHeader/PageHeader";
import Footer from "../shared/Footer";

import NavigationMenu from "../shared/navigationMenu/NavigationMenu";
import Header from "../shared/header/Header";
import { fetchData, fetchFormData } from "../../utils/options";
import Swal from "sweetalert2";
import { format, startOfMonth, endOfMonth } from "date-fns";

const Home = () => {
  const navigate = useNavigate();
  const [dashboardData, setDashboardData] = useState([]);
  useEffect(() => {
    window.scrollTo(0, 0);
    if (localStorage.getItem("access_token") === null) {
      navigate("/");
    }
  }, []);

  useEffect(() => {
    const fetchDashboard = async () => {
      try {
        const result = await fetchData("dashboard-count", {}, "GET");
// console.log(result)
        if (result?.code === 200) {
          setDashboardData(result.data);
          console.log(result.data)
        }
      } catch (error) {
        console.error("Dashboard API Error:", error);
      }
    };

    fetchDashboard();
  }, []);

  return (
    <>
      <Header />
      <NavigationMenu />
      <main className="nxl-container">
        <div className="nxl-content">
          <PageHeader>
            <PageHeaderDate />
          </PageHeader>
          <div className="main-content">
            <div className="row">
              <SiteOverviewStatistics dashboardData={dashboardData} />

           
            </div>
          </div>
          <Footer />
        </div>
      </main>
    </>
  );
};

export default Home;
